import React from 'react';
import PropTypes from 'prop-types';

import StandardInputText from '@/common/components/input/StandardInputText';

interface Props {
  courseName: string;
  onChange: (field: string, value: any) => void;
}

const CourseNameStep: React.FC<Props> = ({ courseName, onChange }) => (
  <div className='flex flex-col gap-[16px] w-full'>
    <div className='flex flex-col gap-2 bg-surface_gray_200 rounded-lg p-4 border border-border_gray_300'>
      <p className='text-base'>Enter a name for your new course.</p>
      <p className='text-sm text-text_gray_900'>
        Choose a clear and descriptive name that reflects the course content.
      </p>
    </div>

    <StandardInputText
      id='courseName'
      label='Course Name'
      isRequired={true}
      value={courseName}
      onChange={(e) => onChange('name', e.target.value)}
    />
  </div>
);

CourseNameStep.propTypes = {
  courseName: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default CourseNameStep;
